import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { PartnerType } from '@tgx/shared/enums';
import { SelectorOrganization, UserData } from '@tgx/shared/interfaces';
import { PlatformInfoService } from '@tgx/shared/services';
import { Subscription } from 'rxjs';
import { OnboardingImplementationService } from '../../services/onboarding-implementation.service';
import { OnboardingProgessService } from '../../services/onboarding-progess.service';

@Component({
  selector: 'tgx-onboarding-implementation-seller-push',
  templateUrl: './onboarding-implementation-seller-push.component.html',
  styleUrls: ['./onboarding-implementation-seller-push.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class OnboardingImplementationSellerPushComponent implements OnInit, OnDestroy {
  private platformInfoService = inject(PlatformInfoService);
  private onboardingProcessService = inject(OnboardingProgessService);
  private onboardingService = inject(OnboardingImplementationService);

  organization: SelectorOrganization;
  loggedUser: UserData;
  companyName: string;
  userImg: string;

  subscriptions: Subscription[] = [];

  askContact = false; // Flag to control the visibility of the contact button

  private readonly notificationEmail = 'client-onboarding@travelgate.com';

  ngOnInit(): void {
    this.subscriptions.push(
      this.platformInfoService.organizationSelected$.subscribe((org) => {
        this.organization = org as SelectorOrganization;
        this.companyName = org.label;

        this.onboardingProcessService.setStartDate(this.organization.code, PartnerType.SELLER);
      }),
    );

    this.subscriptions.push(
      this.platformInfoService.userLogged$.subscribe((userData) => {
        this.loggedUser = userData;
        this.userImg = userData.picture;
      }),
    );
  }

  /**
   * Sends an email notification to 'client-onboarding@travelgate.com' with the buyer orgCode requesting for support
   */
  async sendSupportRequest(type: 'Buyer' | 'Seller') {
    this.onboardingService.sendSupportRequest(type, this.organization.label, this.organization.code);
    this.askContact = true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
